import React, { Component } from 'react';
import BehaviorModal from './behavior_Modal';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { renderTextField, renderAutoCompleteSingleSelect, renderDateField, renderTimePicker, isInteger, isFloat, renderCheckBox } from '../../../../../../components/reduxFields';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../components/SortingCustom';
import { change, Field, FieldArray, reduxForm, reset } from 'redux-form';
import { resetFiltersAndSorting, alertConfirmation } from '../../../../../../actions/utilAction';
import { deleteBehavior, getBehaviorList, getMasterData, SaveRawBehaviorData, copyPatientBehaviorReduction,getPatientBehaviorsReductionForDailySummary } from './actions/behaviorActions';
import SubString from 'add-ellipsis';
import Tooltip from '../../../../../../components/Tooltip';
import { CommonButton } from '../../../../../../components/buttons';
import RawDataModal from './RawDataModal';
import FrequencyGraphModal from './FrequencyGraphModal/index';
import DurationGraphModal from './DurationGraphModal/index';
import RateGraphModal from './RateGraphModal/index';
import PartialIntervalGraphModal from './PartialIntervalGraphModal/index';
import MomentaryTimeSampleGraphModal from './MomentaryTimeSampleGraphModal/index';
import _ from 'lodash';
import moment from 'moment';
import { clearFieldErrorArray } from '../../../../../../modules/AppConfig/actions';
import { UpdateDCArchiveStatus } from '../../../../../MastersDataCollection/curriculumLibraries/actions/CurriculumLibrariesActions';
import { delay } from 'lodash';
const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};

class Behavior extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      behaviorId: null,
      recordingTypeName: '',
      behaviorName: '',
      behaviorObj: null,
      patientId: props.patientId,
      rawDataModal: false,
      durationGraphModalOpen: false,
      frequencyGraphModalOpen: false,
      rateGraphModalOpen: false,
      partialIntervalGraphModalOpen: false,
      momentaryTimeSampleGraphModalOpen: false,
      modalTitle: '',
      sessionDate: [],
      sessionTime: [],
      isAddRawDataClicked: false,
      selectedReductionsIds: [],     
      ShowArchivedOnly : false,
      modalFlag:false
    };

    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.renderBehavior = this.renderBehavior.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.CheckReduction = this.CheckReduction.bind(this);
    this.ResetAllCheckBoxes = this.ResetAllCheckBoxes.bind(this);
    this.handleCloneProgramClick = this.handleCloneProgramClick.bind(this);
  }

  componentWillMount() {
    let masterData = { 'masterdata': 'MASTERSTAFFACTIVEANDINACTIVE' };
    this.props.getMasterData(masterData);
    this.loadData();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.deleted_behavior && nextProps.deleted_behavior !== this.props.deleted_behavior) {
      this.loadData();
    }
    if (nextProps.saved_behavior && nextProps.saved_behavior !== this.props.saved_behavior) {
      this.loadData();
    }
    if (nextProps.save_copyPatientBehaviorReduction && nextProps.save_copyPatientBehaviorReduction !== this.props.save_copyPatientBehaviorReduction) {
      this.loadData();
    }

    if (nextProps.archiveBatchDCStatus && nextProps.archiveBatchDCStatus !== this.props.archiveBatchDCStatus) {
      this.setState({ selectedReductionsIds : [] },()=>{
        this.ResetAllCheckBoxes();
        this.loadData();
      });      
    }  

  }

  componentDidUpdate(prevProps){
      if(prevProps.isDataCollectedInDailySummaryData !== this.props.isDataCollectedInDailySummaryData){
        if(this.props.isDataCollectedInDailySummaryData&&this.props.isDataCollectedInDailySummaryData.isDataCollectedInDailySummaryData){
          this.alertRaiser()      
        }
     }  
    
  }

  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { searchText: this.filter.searchText || null, patientId: this.state.patientId || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0', },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getBehaviorList(searchObj, this.props.patientId);
  }


  handleOpen() {
    Alert.closeAll();
    this.setState({ open: true, behaviorId: null, recordingTypeName: '', behaviorName: '', behaviorObj: null });
  }
  handleClose() {
    this.setState({ open: false, behaviorId: null, recordingTypeName: '', behaviorName: '', rawDataModal: false, frequencyGraphModalOpen: false, durationGraphModalOpen: false, rateGraphModalOpen: false, partialIntervalGraphModalOpen: false, momentaryTimeSampleGraphModalOpen: false });
  };

  handleEditClick = (e, obj) => {
    Alert.closeAll();
    this.setState({
      open: true,
      behaviorId: obj.id,
      behaviorObj: obj,
    });
  };

  handleAlertClick = (event, Id) => {
    Alert.closeAll();
    this.props.deleteBehavior(Id);
  };

  handleDeleteClick = (e, obj) => {
    let warningMsg = `Are you sure you want to delete this behavior?`;
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  handleCloneAlert = (Id) => {
    Alert.closeAll();
    let postData = {
        "PatientId": parseInt(this.state.patientId),
        "BehaviorReductionId": this.state.behaviorId,
    };
    this.props.copyPatientBehaviorReduction(postData);
  };


  handleCloneProgramClick = (e, obj) => {
    this.setState({
      behaviorId : obj.id
    })
    Alert.closeAll();
    let warningMsg = `Would you like to copy this item? You can edit it later.`;
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleCloneAlert,
        id: obj.id,
      },
    })
  } 

  setSortColumn(col_name, col_order) {
    this.filter.sort_Column = col_name;
    this.filter.sort_order = col_order;
    this.loadData();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('Behaviorform'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.setState({ ShowArchivedOnly : false  }, ()=>{this.loadData();});
  }

  handleSubmitSearch() {
    return false;
  }

  handleViewRawDataClick = (e, obj, type) => {
    if (type.toUpperCase() === "BEHAVIOR") {
      this.setState({
        rawDataModal: true,
        behaviorId: obj.id,
        recordingTypeName: obj.recordingTypeName.toUpperCase(),
        behaviorName: obj.behaviorName.toUpperCase(),
      })
    }
  }

  ResetAllCheckBoxes()
  {
    this.props.behaviorListData != null && this.props.behaviorListData && this.props.behaviorListData.data.forEach((obj, Index) => {
        let idCheck = `Claims[${Index}].Chk`;                
        this.props.dispatch(change('Behaviorform', idCheck, false));                
    });
  }

  CheckReduction(e, index, data) {    
    let selectedReductionsIds = this.state.selectedReductionsIds;        
    let isChecked = e.target.checked;
    if (isChecked) {     
      selectedReductionsIds.push(data.id);              
    } else {     
        index = selectedReductionsIds.findIndex((value) => value === data.id);
        if (index >= 0) {
          selectedReductionsIds.splice(index, 1);         
        }      
    }
    this.setState({ selectedReductionsIds });
  }

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadData();
      });
  }

  handleAlertArchiveBatchReductionsClick = (event) => {
    this.props.UpdateDCArchiveStatus(this.state.selectedReductionsIds.toString(), true, 'BehaviorsReduction');
    Alert.closeAll();
  }

  handleArchiveBatchReductionsClick = (event) => {
    Alert.warning('Are you sure you want to archive selected behavior reduction(s)?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertArchiveBatchReductionsClick,
        //id: obj.id,
      },
    });
  }

  handleAlertUnArchiveBatchReductionsClick = (event) => {
    this.props.UpdateDCArchiveStatus(this.state.selectedReductionsIds.toString(), false, 'BehaviorsReduction');
    Alert.closeAll();
  }

  handleUnArchiveBatchReductionsClick = (event) => {
    Alert.warning('Are you sure you want to unarchive selected behavior reduction(s)?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertUnArchiveBatchReductionsClick,
        //id: obj.id,
      },
    });
  }

  alertCloser = ()=>{
    this.setState({modalFlag:true})
    Alert.closeAll()
  }
  modalCloser = ()=>{
    if(!this.state.modalFlag){
      this.setState({isAddRawDataClicked:false})
    }
    this.setState({modalFlag:false})
  }

  alertRaiser = ()=>{
    Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
        position: 'bottom-right',
        effect: 'slide',
        timeout: 10000,
        customFields: {
          displayComponent: true,
          handleButtonClick: this.alertCloser,
          // id: obj.id,
        },
        onClose : this.modalCloser
      });
 }

 convertToHHmmss=(input)=>{
  let date;

  // Check if input matches the format DD:MM:YYTHH:mm:ss
  if (/^\d{2}:\d{2}:\d{2}T\d{2}:\d{2}:\d{2}$/.test(input)) {
      const [datePart, timePart] = input.split('T');
      const [day, month, year] = datePart.split(':');
      const [hours, minutes, seconds] = timePart.split(':');
      date = new Date(`20${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
  }
  // Check if input matches the 12-hour format HH:mm am/pm
  else if (/^\d{1,2}:\d{2}\s?(am|pm)$/i.test(input)) {
      date = new Date(`1970-01-01 ${input}`);
  }
  // Check if input matches ISO 8601 format (e.g., YYYY-MM-DDTHH:mm:ss±HH:mm)
  else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})?$/.test(input)) {
      date = new Date(input);
  }
  // Handle invalid input
  else {
      throw new Error('Invalid input format');
  }

  // Format to HH:mm:ss
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}


  callAlertOrCallSumbit = (formData)=>{
      this.onSubmitHandler(formData); 
 }

  

  onSubmitHandler(formData) {
    // console.log(formData);
    Alert.closeAll()
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    this.props.clearFieldErrorArray();

    // ---------------Start Save to patientBehvaiorRawData ------------
    // console.log(formData.patientBehvaiorRawData);
    let listRawDATA = [];
    if (formData.patientBehvaiorRawData && formData.patientBehvaiorRawData.length) { //  Save Tags
      formData.patientBehvaiorRawData.filter((data, i) => {
        if (data.id) {
          let timeVal  = this.convertToHHmmss(data.sessionTime)
          let sessionDate = moment(data.sessionDate).format('YYYY-MM-DD') + 'T' + timeVal;

          if (this.state.recordingTypeName.toUpperCase() === 'FREQUENCY') {
            let currentData = {
              'sessionDate': sessionDate,
              'staffId': data.id,
              'value': data.value,
              'duration': null,
              'patientId': this.state.patientId,
              'behaviorsReductionId': this.state.behaviorId,
              'actionString': this.state.recordingTypeName.toUpperCase(),
              'recordingTypeName': this.state.recordingTypeName.toUpperCase(),
            };
            listRawDATA.push(currentData);
          }
          else if (this.state.recordingTypeName.toUpperCase() === 'DURATION') {
            let currentData = {
              'sessionDate': sessionDate,
              'staffId': data.id,
              'value': null,
              'duration': data.duration,
              'patientId': this.state.patientId,
              'behaviorsReductionId': this.state.behaviorId,
              'actionString': this.state.recordingTypeName.toUpperCase(),
              'recordingTypeName': this.state.recordingTypeName.toUpperCase(),
            };
            listRawDATA.push(currentData);
          }
          else if (this.state.recordingTypeName.toUpperCase() === 'RATE') {
            let currentData = {
              'sessionDate': sessionDate,
              'staffId': data.id,
              'value': data.value,
              'duration': data.duration,
              'patientId': this.state.patientId,
              'behaviorsReductionId': this.state.behaviorId,
              'actionString': this.state.recordingTypeName.toUpperCase(),
              'recordingTypeName': this.state.recordingTypeName.toUpperCase(),
            };
            listRawDATA.push(currentData);
          }
          else if (this.state.recordingTypeName.toUpperCase() === 'PARTIAL INTERVAL') {
            let currentData = {
              'sessionDate': sessionDate,
              'staffId': data.id,
              'value': (data.value.toUpperCase() === 'YES' ? 1 : 0),
              'duration': data.duration,
              'patientId': this.state.patientId,
              'behaviorsReductionId': this.state.behaviorId,
              'actionString': this.state.recordingTypeName.toUpperCase(),
              'recordingTypeName': this.state.recordingTypeName.toUpperCase(),
            };
            listRawDATA.push(currentData);
          }
          else if (this.state.recordingTypeName.toUpperCase() === 'MOMENTARY TIME SAMPLE') {
            let currentData = {
              'sessionDate': sessionDate,
              'staffId': data.id,
              'value': (data.value.toUpperCase() === 'YES' ? 1 : 0),
              'duration': data.duration,
              'patientId': this.state.patientId,
              'behaviorsReductionId': this.state.behaviorId,
              'actionString': this.state.recordingTypeName.toUpperCase(),
              'recordingTypeName': this.state.recordingTypeName.toUpperCase(),
            };
            listRawDATA.push(currentData);
          }
        }
        return listRawDATA;
      });
    }
    formData.patientBehvaiorRawData = listRawDATA;
    // ---------------End Save to patientBehvaiorRawData ------------
    //console.log('formData.............',formData)
    this.props.SaveRawBehaviorData(formData, this.state.patientId);
    this.setState({ isAddRawDataClicked: false });
    //this.props.closeDialog();
  }

  onDateChange = (input, value, i) => {
    if(input.name===`patientBehvaiorRawData[${i}].sessionDate`){
      this.props.getPatientBehaviorsReductionForDailySummary(this.props.patientId,this.state.behaviorId,moment(value).format('YYYY-MM-DD'));
    }
     
    input.onChange(moment(value).format());
    let sessionDate = this.state.sessionDate;

    _.update(sessionDate, `[${i}]`, function (n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    this.setState({ sessionDate: sessionDate }, ()=>{                  
      document.getElementsByName(`patientBehvaiorRawData[${i}].sessionTime`)[0].focus();           
   });

   
  }

  onTimeChange = (input, value, i) => {

    input.onChange(moment(value).format());
    let sessionTime = this.state.sessionTime;

    _.update(sessionTime, `[${i}]`, function (n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    this.setState({ sessionTime: sessionTime }, ()=>{                  
      document.getElementsByName(`patientBehvaiorRawData[${i}].sessionDate`)[0].focus();           
   });
  }

  handleNewRequestStatus = (input, selectedRecord, targetId) => {
    input.onChange(selectedRecord.value);
  };

  handleBackToBehaviors = () => {
    this.setState({
      isAddRawDataClicked: false
    });
  }

  handleAddRawDataClick = (e, obj, type) => {
    this.setState({
      isAddRawDataClicked: true,
      sessionDate: [],
      sessionTime: [],
      behaviorId: obj.id,
      recordingTypeName: obj.recordingTypeName.toUpperCase(),
      behaviorName: obj.behaviorName.toUpperCase(),
    }, () => {
      this.props.dispatch(change('Behaviorform', `patientBehvaiorRawData`, [{}]));
    })
  }

  addRow = () => { };
  removeRow = (i) => { };

  renderRawDataListTemplate = ({ fields }) => {
    this.addRow = (e) => {
      fields.push({});
    };

    this.removeRow = (i, e) => {
      fields.remove(i);
    };

    return (
      <div>
        {fields.map((patientBehvaiorRawData, i) =>
          <div className="row" key={i}>
            <div className="col-sm-2 mt-40">
              <Field
                name={`patientBehvaiorRawData[${i}].id`}
                hintText="Staff Name"
                handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                options={this.props.allStaffs}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-2">
              <Field
                name={`patientBehvaiorRawData[${i}].sessionDate`}
                placeholder="Session Date"
                locale="en-US"
                selected={this.state.sessionDate[i] || null}
                onDateChange={(input, value) => this.onDateChange(input, value, i)}
                openToYearSelection={true}
                component={renderDateField} />
            </div>
            <div className="col-sm-2">
              <Field
                name={`patientBehvaiorRawData[${i}].sessionTime`}
                placeholder="Time"
                fullWidth={true}
                selected={this.state.sessionTime[i] || null}
                component={renderTimePicker}
                onDateChange={(input, value) => this.onTimeChange(input, value, i)}
              />
            </div>
            {this.state.recordingTypeName.toUpperCase() === "DURATION" || this.state.recordingTypeName.toUpperCase() === "RATE" ?
              <div className="col-sm-2">
                <Field
                  name={`patientBehvaiorRawData[${i}].duration`}
                  type="text"
                  maxLength="5"
                  label="Duration In Min."
                  component={renderTextField}
                  normalize={isFloat}
                />
                <small>(Ex: 15 sec = 0.25 min)</small>
              </div> : null}
            {this.state.recordingTypeName.toUpperCase() === "FREQUENCY" || this.state.recordingTypeName.toUpperCase() === "RATE" ?
              <div className="col-sm-2">
                <Field
                  name={`patientBehvaiorRawData[${i}].value`}
                  type="text"
                  maxLength="2"
                  label="Value"
                  component={renderTextField}
                  normalize={isInteger}
                />
              </div> : null}
              {this.state.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL" || this.state.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE" ?
                <div className="col-sm-2">
                   <Field
                      name={`patientBehvaiorRawData[${i}].duration`}
                      type="text"
                      maxLength="2"
                      label="Interval"
                      component={renderTextField}
                      normalize={isInteger}
                    />
                </div> : null}
              {this.state.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL" || this.state.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE" ?
                <div className="col-sm-2">
                  <Field
                      name={`patientBehvaiorRawData[${i}].value`}
                      type="text"
                      maxLength="3"
                      label="Value (Enter “Yes” or “No”)"
                      component={renderTextField}                                                     
                  />
                </div> : null}
            {fields.length === i + 1 ?
              <div className="col-sm-2 mt-40">
                {fields.length > 1 ?
                  <button className=" additemtable removeitemtable"
                    onClick={this.removeRow.bind(this, i)}
                    title="Remove Data"
                    type="button">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                  : ''}
                <button className="additemtable" title="Add Data" onClick={(e) => this.addRow()} type="button">
                  <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                </button>
              </div>
              :
              <div className="col-sm-2 mt-40">
                <button className="additemtable"
                  onClick={this.removeRow.bind(this, i)}
                  title="Remove Data"
                  type="button">
                  <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                </button>
              </div>

            }
          </div>
        )}
      </div>
    );
  };

  onGraphClickHandler = (data) => {
    if (data.recordingTypeName.toUpperCase() === "FREQUENCY") {
      this.setState({
        durationGraphModalOpen: false,
        rateGraphModalOpen: false,
        partialIntervalGraphModalOpen: false,
        momentaryTimeSampleGraphModalOpen: false,
        frequencyGraphModalOpen: true,
        modalTitle: data.behaviorName,
        recordingTypeName: data.recordingTypeName,
        behaviorsReductionId: data.id
      });
    } else if (data.recordingTypeName.toUpperCase() === "DURATION") {
      this.setState({
        frequencyGraphModalOpen: false,
        rateGraphModalOpen: false,
        partialIntervalGraphModalOpen: false,
        momentaryTimeSampleGraphModalOpen: false,
        durationGraphModalOpen: true,
        modalTitle: data.behaviorName,
        recordingTypeName: data.recordingTypeName,
        behaviorsReductionId: data.id

      });
    } else if (data.recordingTypeName.toUpperCase() === "RATE") {
      this.setState({
        frequencyGraphModalOpen: false,
        durationGraphModalOpen: false,
        momentaryTimeSampleGraphModalOpen: false,
        partialIntervalGraphModalOpen: false,
        rateGraphModalOpen: true,
        modalTitle: data.behaviorName,
        recordingTypeName: data.recordingTypeName,
        behaviorsReductionId: data.id

      });
    } else if (data.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL") {
      this.setState({
        frequencyGraphModalOpen: false,
        durationGraphModalOpen: false,
        rateGraphModalOpen: false,
        momentaryTimeSampleGraphModalOpen: false,
        partialIntervalGraphModalOpen: true,
        modalTitle: data.behaviorName,
        recordingTypeName: data.recordingTypeName,
        behaviorsReductionId: data.id

      });
    } else if (data.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE") {
      this.setState({
        frequencyGraphModalOpen: false,
        durationGraphModalOpen: false,
        rateGraphModalOpen: false,
        partialIntervalGraphModalOpen: false,
        momentaryTimeSampleGraphModalOpen: true,
        modalTitle: data.behaviorName,
        recordingTypeName: data.recordingTypeName,
        behaviorsReductionId: data.id

      });
    }
  }

  renderBehavior = (behaviorList) => {
    behaviorList = behaviorList || [];

    if (!behaviorList.length) {
      return (
        <tr>
          <td colSpan="7">
            <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }
    return behaviorList.map((data, index) => {
      return (
        <tr key={index}>
          <td width="5%">
              <div className="table_custom-check">
              <Field
                  name={`Claims[${index}].Chk`}
                  component={renderCheckBox}
                  onChange={(e) => this.CheckReduction(e, index, data)}
                  style={stylescss.checkbox}
              />
              </div>
          </td>
          <td>{data.behaviorName}</td>
          <td>
            {data.description && data.description.length > 0 ?
              <Tooltip Description={data.description} />
              : null}
            {data.description != null && data.description.length > 30 ? SubString(data.description, 30) : data.description != null ? data.description : 'N/A'}
          </td>
          <td>{data.recordingTypeName}</td>
          <td>{data.behaviorCategoryName}</td>
          <td>{data.todaysData}</td>
          {/* <td style={{ cursor: 'pointer' }} onClick={() => this.onGraphClickHandler(data)}><a>GRAPH</a></td> */}
          {this.props.updatePermission || this.props.deletePermission || this.props.viewBehviorGraphPermission ?
            <td>              
              <button onClick={(e) => this.handleAddRawDataClick(e, data, 'behavior')} type="button" title="Add Raw Data" className="tbactionbtn redfont"><i className="fa fa-plus-square" aria-hidden="true"></i></button>              
              {this.props.viewBehviorGraphPermission && data.recordingTypeName ?
                <button onClick={() => this.onGraphClickHandler(data)} type="button" title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                : null}
              {this.props.viewRawDataPermissionBehavior ?
                <button onClick={(e) => this.handleViewRawDataClick(e, data, 'behavior')} type="button" title="Raw Data" className="tbactionbtn bluefont"><i className="fa fa-list" aria-hidden="true"></i></button>
                : null}
              {this.props.updatePermission ?
                <button onClick={(e) => this.handleEditClick(e, data)} title="Edit" type="button" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                : null}
              {this.props.deletePermission ?
                <button onClick={(e) => this.handleDeleteClick(e, data)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                : null}
              {this.props.copyPermissionProgram ?
                  <button type="button" onClick={(e) => this.handleCloneProgramClick(e, data)} title="Clone" className="tbactionbtn bluefont"><i className="fa fa-clone" aria-hidden="true"></i></button>
                  : null}
            </td>
            : null}
        </tr>
      );
    });
  };

  render() {
    const { handleSubmit, behaviorListData } = this.props,
      behaviorList = (behaviorListData && behaviorListData.data) || [],
      promptCodeMeta = (behaviorListData && behaviorListData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        {this.state.open ?
          <BehaviorModal
            open={this.state.open}
            patientId={this.state.patientId}
            closeDialog={this.handleClose}
            behaviorId={this.state.behaviorId}
            behaviorObj={this.state.behaviorObj}
          /> : ''}
        {
          this.state.rawDataModal &&
          <RawDataModal
            behaviorId={this.state.behaviorId}
            patientId={this.state.patientId}
            recordingTypeName={this.state.recordingTypeName}
            behaviorName={this.state.behaviorName}
            //  targetType={this.state.ClickedTargetType}
            closeDialog={() => this.handleClose()}
          />
        }

        {!this.state.isAddRawDataClicked ?

          <div className="row mt-3">
            <div className="col-sm-3">
              {this.props.addPermission ?
                  <RaisedButton label="Add New Behavior" primary={true} onTouchTap={this.handleOpen} />
                  : null}
            </div>
            <div className="col-sm-3">
                <CommonButton className={this.state.selectedReductionsIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedReductionsIds.length > 0 && !this.state.ShowArchivedOnly ? false : true} label="Mark as Archived" onTouchTap={(e) => this.handleArchiveBatchReductionsClick(e)} />
            </div>
            <div className="col-sm-3">
                <CommonButton className={this.state.selectedReductionsIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedReductionsIds.length > 0 && this.state.ShowArchivedOnly ? false : true} label="Mark as Unarchived" onTouchTap={(e) => this.handleUnArchiveBatchReductionsClick(e)} />
            </div>
            <div className="col-sm-3 field-mr">
                <Field
                name="ShowArchivedOnly"
                label="Show Archived Only"
                component={renderCheckBox}
                onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowArchivedOnly')}
                />
            </div>  
            <div className="col-sm-3 mt-20">
              <div className="row end-flex">
                <div className="col-sm-6 mtm-27">
                  <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)}>
                    <Field
                      name="Name"
                      floatingLabelText="Search"
                      maxLength="10"
                      onChange={this.handleSearchChange}
                      component={renderTextField}
                      fullWidth={true}
                    />
                  </form>
                </div>
                <div className="reset-btn col-sm-3">
                  <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton} >Reset</RaisedButton>
                </div>
              </div>
            </div>
          </div>
          : <div className="row">
            <div className="col-sm-3 mt-10">
              <RaisedButton
                //style={{ marginTop: '10px', marginBottom: '10px' }} 
                label="Back" primary={true} onTouchTap={() => this.handleBackToBehaviors()} />
            </div>
          </div>
        }

        {!this.state.isAddRawDataClicked ?
          <div>
            <div className="table-responsive mt-15">
              <table className={tableClass}>
                <thead>
                  <tr>
                    <th width="5%"></th>
                    <th width="25%">
                      {<SortingCustom noSort={!behaviorList.length} setSortColumn={this.setSortColumn} columnName='behaviorName' displayName='Behavior Name' />}
                    </th>
                    <th width="20%">Definition</th>
                    <th width="15%">Type</th>
                    <th width="15%">Category</th>
                    <th width="10%">Data Today</th>
                    {/* <th width="10%">Graph</th> */}
                    {this.props.updatePermission || this.props.deletePermission || this.props.viewBehviorGraphPermission ?
                      <th width="10%">Actions</th>
                      : null
                    }
                  </tr>
                </thead>
                <tbody>
                  {this.renderBehavior(behaviorList)}
                </tbody>
              </table>
            </div>
            {promptCodeMeta && promptCodeMeta['totalPages'] ?
              <PaginatorCustom data={promptCodeMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
              : null
            }
            {
              this.state.frequencyGraphModalOpen &&
              <FrequencyGraphModal
                patientId={this.state.patientId}
                closeDialog={() => this.handleClose()}
                recordingTypeName={this.state.recordingTypeName}
                behaviorsReductionId={this.state.behaviorsReductionId}
                modalTitle={this.state.modalTitle}
              />
            }
            {
              this.state.durationGraphModalOpen &&
              <DurationGraphModal
                patientId={this.state.patientId}
                closeDialog={() => this.handleClose()}
                recordingTypeName={this.state.recordingTypeName}
                behaviorsReductionId={this.state.behaviorsReductionId}
                modalTitle={this.state.modalTitle}
              />
            }
            {
              this.state.rateGraphModalOpen &&
              <RateGraphModal
                patientId={this.state.patientId}
                closeDialog={() => this.handleClose()}
                recordingTypeName={this.state.recordingTypeName}
                behaviorsReductionId={this.state.behaviorsReductionId}
                modalTitle={this.state.modalTitle}
              />
            }
            {
              this.state.partialIntervalGraphModalOpen &&
              <PartialIntervalGraphModal
                patientId={this.state.patientId}
                closeDialog={() => this.handleClose()}
                recordingTypeName={this.state.recordingTypeName}
                behaviorsReductionId={this.state.behaviorsReductionId}
                modalTitle={this.state.modalTitle}
              />
            }
            {
              this.state.momentaryTimeSampleGraphModalOpen &&
              <MomentaryTimeSampleGraphModal
                patientId={this.state.patientId}
                closeDialog={() => this.handleClose()}
                recordingTypeName={this.state.recordingTypeName}
                behaviorsReductionId={this.state.behaviorsReductionId}
                modalTitle={this.state.modalTitle}
              />
            }
          </div>
          :
          <div>
            <div className="clearfix"></div>
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.callAlertOrCallSumbit.bind(this))} >
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Add Raw {this.state.recordingTypeName.toUpperCase()} Data</h3>
                    <i className="flaticon flaticon-calendar-1"></i>
                  </div>

                  <FieldArray name="patientBehvaiorRawData" component={this.renderRawDataListTemplate} />

                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 mt-20"></div>
                <div className="col-sm-6 pt20 btn_rt">
                  <CommonButton type="submit" className="ml_15" primary={true} label="Save Raw Data" />
                </div>
              </div>
            </form>
          </div>
        }
      </div>
    );
  }
}

Behavior = reduxForm({
  form: 'Behaviorform',
})(Behavior);

function mapStateToProps(state) {

  let initialValueData = {
    patientBehvaiorRawData: [{}],
  };
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_BEHAVIOURS")[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_UPDATE_BEHAVIOURS")[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_DELETE_BEHAVIOURS")[0].permission : false;
  let viewBehviorGraphPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_VIEW_BEHAVIOURS_GRAPH")[0].permission : false;
  let viewRawDataPermissionBehavior = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_VIEW_RAW_DATA")[0].permission : false;
  let copyPermissionProgram = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_COPY_PROGRAM")[0].permission : false;
  // End For Role Permission

  let patientBehaviorsReductionForDailySummary = null
  let isDataCollectedInDailySummaryData = null;
  if(state.patient_behavior && state.patient_behavior.patientBehaviorsReductionForDailySummary){
    patientBehaviorsReductionForDailySummary = state.patient_behavior.patientBehaviorsReductionForDailySummary;
    if(patientBehaviorsReductionForDailySummary.data &&patientBehaviorsReductionForDailySummary.data[0] && patientBehaviorsReductionForDailySummary.data[0].isDataCollectedInDailySummaryData){
        isDataCollectedInDailySummaryData = patientBehaviorsReductionForDailySummary.data[0];
    }
  }


  return {
    loading: state.patient_behavior.loading,
    behaviorListData: state.patient_behavior.behaviorList,
    deleted_behavior: state.patient_behavior.deleted_behavior,
    saved_behavior: state.patient_behavior.saved_behavior,
    save_copyPatientBehaviorReduction :state.patient_behavior.save_copyPatientBehaviorReduction,
    addPermission: addPermission, // For Role Permission
    updatePermission: updatePermission, // For Role Permission
    deletePermission: deletePermission, // For Role Permission
    copyPermissionProgram: copyPermissionProgram,
    viewBehviorGraphPermission: viewBehviorGraphPermission, // For Role Permission
    viewRawDataPermissionBehavior: viewRawDataPermissionBehavior, // For Role Permission
    allStaffs: state.patient_behavior.masterData ? state.patient_behavior.masterData.allStaffsActiveAndInactive : [],
    initialValues: initialValueData,
    archiveBatchDCStatus: state.curriculumLibraries.archiveBatchDCStatus,
    patientBehaviorsReductionForDailySummary,
    isDataCollectedInDailySummaryData
  };
}

export default connect(mapStateToProps, {copyPatientBehaviorReduction, deleteBehavior, getBehaviorList, getMasterData, SaveRawBehaviorData, clearFieldErrorArray, UpdateDCArchiveStatus, getPatientBehaviorsReductionForDailySummary })(Behavior);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Behavior/index.js